import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { today } from "@/lib/partner";
import { toast } from "sonner";

export const Field = ({ label, children }) => <div><Label className="text-xs">{label}</Label><div className="mt-1">{children}</div></div>;
export const Sel = ({ value, onChange, options, testid, placeholder }) => (
  <Select value={value || undefined} onValueChange={onChange}><SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder || "Choisir"} /></SelectTrigger>
    <SelectContent>{options.map((o) => { const [v, l] = Array.isArray(o) ? o : [o, o]; return <SelectItem key={v} value={v}>{l}</SelectItem>; })}</SelectContent></Select>
);

export const blankAction = (extra = {}) => ({ type: "Appel téléphonique", titre: "", description: "", responsable_id: "", date_prevue: today(), heure: "", priorite: "Moyenne", statut: "À faire", ...extra });

export function ActionFields({ a, setA, meta }) {
  return (
    <div className="grid sm:grid-cols-2 gap-3">
      <Field label="Type d'action"><Sel value={a.type} onChange={(v) => setA({ ...a, type: v })} options={meta.config.action_types || []} testid="action-type" /></Field>
      <Field label="Titre"><Input value={a.titre} onChange={(e) => setA({ ...a, titre: e.target.value })} data-testid="action-title" /></Field>
      <Field label="Date prévue"><Input type="date" value={a.date_prevue} onChange={(e) => setA({ ...a, date_prevue: e.target.value })} data-testid="action-date" /></Field>
      <Field label="Responsable"><Sel value={a.responsable_id} onChange={(v) => setA({ ...a, responsable_id: v })} options={meta.users.map((u) => [u.id, u.name])} testid="action-owner" placeholder="Moi-même" /></Field>
      <Field label="Priorité"><Sel value={a.priorite} onChange={(v) => setA({ ...a, priorite: v })} options={["Basse", "Moyenne", "Haute", "Urgente"]} /></Field>
      <Field label="Description"><Input value={a.description} onChange={(e) => setA({ ...a, description: e.target.value })} /></Field>
    </div>
  );
}

export function ActionDialog({ open, onClose, meta, target, onSaved }) {
  const [a, setA] = useState(blankAction());
  useEffect(() => { if (open) setA(blankAction()); }, [open]);
  const save = async () => {
    try { await api.post("/partners/actions", { ...a, ...target }); toast.success("Action planifiée"); onClose(); onSaved(); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="action-dialog"><DialogHeader><DialogTitle className="font-head">Nouvelle action</DialogTitle></DialogHeader>
        <ActionFields a={a} setA={setA} meta={meta} />
        <Button onClick={save} className="bg-brand-600 hover:bg-brand-700 text-white" data-testid="action-save">Enregistrer</Button>
      </DialogContent>
    </Dialog>
  );
}

export function CloseActionDialog({ action, onClose, meta, onSaved }) {
  const [statut, setStatut] = useState("Réalisée");
  const [cr, setCr] = useState("");
  const [date, setDate] = useState("");
  const [next, setNext] = useState(null);
  useEffect(() => { setStatut("Réalisée"); setCr(""); setDate(""); setNext(null); }, [action]);
  if (!action) return null;
  const save = async () => {
    try {
      await api.post(`/partners/actions/${action.id}/status`, { statut, compte_rendu: cr, date_prevue: statut === "Reportée" ? date : "",
        next_action: next ? { ...next, partner_id: action.partner_id, contact_id: action.contact_id } : null });
      toast.success("Action mise à jour"); onClose(); onSaved();
    } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="close-action-dialog"><DialogHeader><DialogTitle className="font-head">{action.type} — {action.titre}</DialogTitle></DialogHeader>
        <Field label="Nouveau statut"><Sel value={statut} onChange={setStatut} options={meta.action_statuses} testid="close-action-status" /></Field>
        {statut === "Reportée" && <Field label="Nouvelle date"><Input type="date" value={date} onChange={(e) => setDate(e.target.value)} /></Field>}
        <Field label="Compte rendu"><Textarea rows={2} value={cr} onChange={(e) => setCr(e.target.value)} data-testid="close-action-cr" /></Field>
        <label className="text-sm flex items-center gap-2"><input type="checkbox" checked={!!next} onChange={(e) => setNext(e.target.checked ? blankAction({ type: "Relance" }) : null)} data-testid="close-action-next" />Programmer la prochaine action</label>
        {next && <ActionFields a={next} setA={setNext} meta={meta} />}
        <Button onClick={save} className="bg-brand-600 hover:bg-brand-700 text-white" data-testid="close-action-save">Enregistrer</Button>
      </DialogContent>
    </Dialog>
  );
}
